<template>
    <v-container class="white elevation-0" grid-list-xl fluid ma-0 pa-0><br />
      <div class="body-2 text--black"> Participant Check In </div>

    <v-layout row wrap class="white elevation-0 mx-3">
      <v-flex sm6 xs12 md2>
        <v-card class="rounded-card">
          <div class="d-flex align-center">
            <v-btn class="elevation-0 red lighten-2 mx-1" small fab dark>
              <v-icon dark small>mdi-chart-bar</v-icon>
            </v-btn>
            <v-list-item-content>
              <div style="color: #334EFF" class="caption text-center">
                Total Participants
              </div>
              <v-list-item-title
                style="color: #290d4d"
                class="subheadline mb-1 text-center"
                >{{ this.getPCPCount() }}</v-list-item-title
              >
            </v-list-item-content>
          </div>
        </v-card>
      </v-flex>

      <v-flex sm6 xs12 md2>
        <v-card class="rounded-card">
          <div class="d-flex align-center">
            <v-btn class="elevation-0 green lighten-2 mx-1" small fab dark>
              <v-icon dark small>mdi-apple</v-icon>
            </v-btn>
            <v-list-item-content>
              <div style="color: #334EFF" class="caption text-center">
                CheckedIn Participants
              </div>
              <v-list-item-title
                style="color: #050a30"
                class="subheadline mb-1 text-center"
                >{{ this.getConfirmed() }}</v-list-item-title>
            </v-list-item-content>
          </div>
        </v-card>
      </v-flex>
    </v-layout>


      <v-layout row justify-center >
        <v-dialog v-model="popupbox" max-width="800px" hide-overlay>
          <v-toolbar outlined color="light-green lighten-2" height="40">
          <v-toolbar-title class="body-2">Edit Event Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn rounded icon outlined filled small dark color='white' @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
          <v-form ref="form" v-model="valid" lazy-validation :close-on-content-click="false" :nudge-right="100" offset-y full-width min-width="650px">
            <v-card><br>
                <div class="d-flex">
                  <v-text-field ref="Json.firstname" outlined dense background-color="amber lighten-5" :rules="nameRules" class="caption mr-2" v-model="Json.firstname" label="First Name" placeholder=" " height="25" required></v-text-field>
                  <v-text-field ref="Json.lastname" outlined dense background-color="amber lighten-5" :rules="nameRules" class="caption mr-2" v-model="Json.lastname" label="Last Name" placeholder=" " height="25"></v-text-field>
                  <v-text-field ref="Json.primaryemail" outlined dense background-color="amber lighten-5" :rules="nameRules" class="caption mr-2" v-model="Json.primaryemail" label="Primary Email" placeholder=" " height="25" required></v-text-field>
                </div>
                <div class="d-flex">
                  <v-select ref="Json.membershipcategory" outlined dense background-color="amber lighten-5" class="caption mr-2" :items="['Family', 'Paarivallal', 'Single', 'NonMember']" v-model="Json.membershipcategory" label="Membership" placeholder=" " height="25"></v-select>
                  <v-select ref="Json.checkinstatus" dense background-color="amber lighten-5" required v-model="Json.checkinstatus" :items="['Y','N']" outlined class="caption mr-2"  placeholder=" " label="Checkin"></v-select>
                  <v-text-field ref="Json.event" outlined dense background-color="amber lighten-5"  class="caption mr-2" v-model="Json.event" label="Event" placeholder=" " height="25"></v-text-field>
                  <v-select ref="Json.eventpayment" dense background-color="amber lighten-5" v-model="Json.eventpayment" :items="['Paid', 'Not Paid']" outlined class="caption mr-2"  placeholder=" " label="Event Payment"></v-select>
                </div>
                <div class="d-flex">
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.kidsCount" dense background-color="amber lighten-5" required v-model.number="Json.kidsCount" outlined class="caption mr-2"  placeholder=" " label="Kids Count"></v-text-field>
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.adultsCount" dense background-color="amber lighten-5" required v-model.number="Json.adultsCount" outlined class="caption mr-2"  placeholder=" " label="Adults Count"></v-text-field>
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.parentsCount" dense background-color="amber lighten-5" required v-model.number="Json.parentsCount" outlined class="caption mr-2"  placeholder=" " label="Parents Count"></v-text-field>
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.totalCount" dense background-color="amber lighten-5" required v-model.number="Json.totalCount" outlined class="caption mr-2"  placeholder=" " label="Total Count  "></v-text-field>
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.totalAmount" dense background-color="amber lighten-5" required v-model.number="Json.totalAmount" outlined class="caption mr-2"  placeholder=" " label="Total Amount"></v-text-field>
                </div>
                 <v-spacer></v-spacer>
                <v-divider></v-divider><br>             
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small outline color="light-green lighten-3" @click="close()">Close</v-btn>
                <v-btn  small outline color="light-green lighten-3" @click="update()" :disabled="!valid">Update</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
  
        <v-dialog v-model="popup" persistent max-width="290">
          <v-card>
            <v-card-title class="body-1 blue">Confirmation</v-card-title>
              <v-card-text class="body-1 blue">info would be deleted ?</v-card-text>
                <v-card-actions class="body-1 b">
                <v-btn small outlined color="primary" text flat @click="confirmdelete(id)">Confirm</v-btn>
                 <v-spacer></v-spacer><v-btn small outlined color="primary" text flat @click="close()">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  
      </v-layout>

      <v-toolbar flat color="text-black" height="55">
          <v-flex sm3 pt-5>
            <v-text-field
              dense
              outlined
              placeholder="Search by all fields"
              class="caption mx-1"
              v-model="search"
            ></v-text-field>
          </v-flex>
          <v-flex>
          <v-btn
            small
            dense
            dark
            rounded
            class="caption blue lighten-1"
            @click="submitCheckIn()"
            >Check In</v-btn>
          <v-avatar size="24" class="red darken-1 elevation-2 mx-1"
            ><v-icon fab xs-small dark @click.stop="clear()"
              >mdi-close</v-icon
            ></v-avatar
          >
          </v-flex>
          <v-spacer></v-spacer>
          <v-avatar size="26" class="light-blue lighten-1 elevation-5 mx-1"
            ><v-icon fab medium dark @click.stop="refresh()"
              >mdi-autorenew</v-icon
            ></v-avatar
          >
          <v-avatar size="26" class="light-blue darken-1 elevation-5 mx-1"
            ><v-icon fab medium dark @click="exportToExcel()"
              >mdi-file-excel</v-icon
            ></v-avatar
          >
      </v-toolbar>
  
      <v-data-table
        dense
        :headers="headers"
        v-model="selected"
        show-select
        :items-per-page="50"
        v-bind:items="allCheckInStatus"
        v-bind:search="search"
        :sort-by="['ProgramCode','ProgramName']"
        :sort-desc="[true, false]"
        multi-sort
        item-key="_id"
        class="caption"
        :loading="loading"
      >
        <template v-slot:item.data-table-select="{ isSelected, select }">
          <v-simple-checkbox
            :value="isSelected"
            @input="select($event)"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.checkinstatus="{ item }">
          <div v-if="item.eventCheckIn === 'Y'">
            <v-avatar size="20" class="green darken-1 elevation-5">
              <v-icon color="white" style="font-size: 15px;">{{
                item.eventCheckIn
              }}</v-icon></v-avatar
            >
          </div>
        </template>
        <template v-slot:item.crud="{ item }">
          <v-avatar size="25" class="light-blue lighten-3 elevation-5 mx-1"
            ><v-icon medium @click="removeCheckIn(item._id)"
                >mdi-account-off</v-icon
            ></v-avatar
            >
        </template>
      </v-data-table>
  
    </v-container>
  </template>
  
  <script>
  import ReportServices from "@/services/ReportServices";
  import XLSX from "xlsx";
  
  export default {
    data() {
      return {
        totalAmount: 0,
        selected: [],
        allEventsData: [],
        allCheckInStatus: [],
        allCount: "",
        search: "",
        loading: true,
        Json: {
          _id: "",
          ProgramCode: "",
          Coordinator: "",
          Participant: "",
          Email: "",
          Prn: ""
        },
        select: null,
        valid: true,
        name: "",
        nameRules: [(v) => !!v || "This Field is required"],
        numberRule: val => {
            if(val < 0) return 'Please enter a positive number'
            return true
        },
        comment: null,
        popupbox: false,
        popup: false,
      };
    },
    computed: {
      loggedInUser() {
        var user = this.$store.getters.email;
        var role = this.$store.getters.role;
        if (user && role === "SuperAdmin") return "SuperAdmin";
        else if (user && role === "Admin") return "Admin";
        else if (user && role === "Member") return "Member";
        else return null;
      },
      headers () {
          if ((this.loggedInUser ==='SuperAdmin') ) {
            return [
              { text: "Checked In", align: "left", value: "checkinstatus", class: "font-weight-black indigo lighten-5 black--text", divider: true },
              { text: "Participant Name", align: "left", value: "Participant", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Program Name", align: "left", value: "ProgramName", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Coordinator", align: "left", value: "Coordinator", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Program Id", align: "left", value: "ProgramCode" , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Email", align: "left", value: "EmailAddress" , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Updated At", align: "left", value: "updatedDate", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "UnCheckIn", value: "crud", class: "font-weight-black indigo lighten-5 black--text", divider: true},
            ]
          } else {
            return [
              { text: "Checked In", align: "left", value: "checkinstatus" , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Participant", align: "left", value: "Participant", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Program Name", align: "left", value: "ProgramName", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Coordinator", align: "left", value: "Coordinator", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Program Id", align: "left", value: "ProgramCode" , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Email", align: "left", value: "EmailAddress" , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "Updated At", align: "left", value: "updatedDate", sortable: true , class: "font-weight-black indigo lighten-5 black--text", divider: true},
              { text: "UnCheckIn", value: "crud", class: "font-weight-black indigo lighten-5 black--text", divider: true},
            ]
          }
      }
    },
    methods: {
      exportToExcel() {
        var allCheckInStatus = XLSX.utils.json_to_sheet(this.allCheckInStatus);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, allCheckInStatus, "allCheckInStatus");
        XLSX.writeFile(wb, "allCheckInStatus.xlsx");
      },
      print() {
        window.print();
      },
      logoutFromFirebase() {
        this.$store
          .dispatch("signOutAction")
          .then(() => this.$router.replace("/Signin"));
      },
      clear() {
        this.search = "";
          this.Json.ProgramCode = "",
          this.Json.Coordinator=  "",
          this.Json.Participant=  "",
          this.Json.Email=  "",
          this.Json.Prn=  ""
      },
      close () {
        this.popupbox = false
        this.popup = false
      },
      removeCheckIn(id) {
        ReportServices.removeCheckIn(id);
        setTimeout(() => {
          this.refresh();
        }, 300);
      },
      update () {
          ReportServices.updateEventData(this.Json)
          this.popupbox = false
          setTimeout(() => {
            this.refresh()
          }, 300)
      },
      getPCPCount() {
        return this.allCheckInStatus.filter(sInfo => sInfo._id !== null).length
      },
      getConfirmed () {
        return this.allCheckInStatus.filter(sInfo => sInfo.eventCheckIn === 'Y').length
      },
      async unselect() {
        this.selected = [];
      },
      isCheckedIn(id) {
        const userExists = this.allCheckInStatus.some((user) => user._id === id);
        if (userExists) {
          return true;
        }
      },
      async submitCheckIn() {
        var checkIns = [];
        this.allCheckInStatus.forEach((sInfo) => {
          var checkInDetails = "";
          var isFound = false;
          this.selected.forEach((i) => {
            if (sInfo._id === i._id) {
              isFound = true;
            }
          });
          if (isFound) {
            checkInDetails = {
              _id: sInfo._id,
            };
          } else return;
          checkIns.push(checkInDetails);
        });
        ReportServices.updateParticipants(checkIns);
        setTimeout(() => {
          this.refresh();
          this.unselect();
        }, 500);
      },
      async refresh() {
        this.loading = true;
        this.allCheckInStatus = (await ReportServices.getParticipants()).data;
        this.loading = false;
        this.noDataText = "No data available";
      },
    },
    async mounted() {
      this.refresh();
    },
  };
  </script>
  
  <style scoped>
  * {
    box-sizing: border-box;
    text-transform: none;
  }
  .title {
    color: white;
    background-color: #617997;
    font-size: medium;
  }
  .rounded-pill{
    border-radius:28px;
}
.test_cursor input {
  cursor: pointer;
}
</style>